export type GroupLetter =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H'
  | 'I'
  | 'J'
  | 'K'
  | 'L'

export type ThirdPlaceHost = 'A' | 'B' | 'D' | 'E' | 'G' | 'I' | 'K' | 'L'
export type SeedRank = 1 | 2 | 3
export type SeedCode = `${SeedRank}${GroupLetter}`
export type MatchId =
  | 'M73'
  | 'M74'
  | 'M75'
  | 'M76'
  | 'M77'
  | 'M78'
  | 'M79'
  | 'M80'
  | 'M81'
  | 'M82'
  | 'M83'
  | 'M84'
  | 'M85'
  | 'M86'
  | 'M87'
  | 'M88'
  | 'M89'
  | 'M90'
  | 'M91'
  | 'M92'
  | 'M93'
  | 'M94'
  | 'M95'
  | 'M96'
  | 'M97'
  | 'M98'
  | 'M99'
  | 'M100'
  | 'M101'
  | 'M102'
  | 'M104'

export type Team = {
  id: string
  name: string
  group: GroupLetter
}

export type QualifiedTeam = Team & {
  seed: SeedCode
}

export type GroupStandings = Record<GroupLetter, Team[]>

export type RoundOf32Match = {
  id: MatchId
  label: string
  home: QualifiedTeam
  away: QualifiedTeam
}

type SeedRef = {
  seed: SeedCode
}

type ThirdPlaceRef = {
  thirdPlaceHost: ThirdPlaceHost
}

type RoundOf32Template = {
  id: MatchId
  label: string
  home: SeedRef | ThirdPlaceRef
  away: SeedRef | ThirdPlaceRef
}

export const GROUP_LETTERS: GroupLetter[] = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
]

const THIRD_PLACE_HOSTS: ThirdPlaceHost[] = [
  'A',
  'B',
  'D',
  'E',
  'G',
  'I',
  'K',
  'L',
]

export const WORLD_CUP_2026_GROUPS: Record<GroupLetter, Team[]> = {
  A: [
    { id: 'mexico', name: 'Mexico', group: 'A' },
    { id: 'south-africa', name: 'South Africa', group: 'A' },
    { id: 'korea-republic', name: 'Korea Republic', group: 'A' },
    { id: 'czechia', name: 'Czechia', group: 'A' },
  ],
  B: [
    { id: 'canada', name: 'Canada', group: 'B' },
    {
      id: 'bosnia-and-herzegovina',
      name: 'Bosnia and Herzegovina',
      group: 'B',
    },
    { id: 'qatar', name: 'Qatar', group: 'B' },
    { id: 'switzerland', name: 'Switzerland', group: 'B' },
  ],
  C: [
    { id: 'brazil', name: 'Brazil', group: 'C' },
    { id: 'morocco', name: 'Morocco', group: 'C' },
    { id: 'haiti', name: 'Haiti', group: 'C' },
    { id: 'scotland', name: 'Scotland', group: 'C' },
  ],
  D: [
    { id: 'usa', name: 'USA', group: 'D' },
    { id: 'paraguay', name: 'Paraguay', group: 'D' },
    { id: 'australia', name: 'Australia', group: 'D' },
    { id: 'turkiye', name: 'Turkiye', group: 'D' },
  ],
  E: [
    { id: 'germany', name: 'Germany', group: 'E' },
    { id: 'curacao', name: 'Curacao', group: 'E' },
    { id: 'cote-divoire', name: "Cote d'Ivoire", group: 'E' },
    { id: 'ecuador', name: 'Ecuador', group: 'E' },
  ],
  F: [
    { id: 'netherlands', name: 'Netherlands', group: 'F' },
    { id: 'japan', name: 'Japan', group: 'F' },
    { id: 'sweden', name: 'Sweden', group: 'F' },
    { id: 'tunisia', name: 'Tunisia', group: 'F' },
  ],
  G: [
    { id: 'belgium', name: 'Belgium', group: 'G' },
    { id: 'egypt', name: 'Egypt', group: 'G' },
    { id: 'ir-iran', name: 'IR Iran', group: 'G' },
    { id: 'new-zealand', name: 'New Zealand', group: 'G' },
  ],
  H: [
    { id: 'spain', name: 'Spain', group: 'H' },
    { id: 'cabo-verde', name: 'Cabo Verde', group: 'H' },
    { id: 'saudi-arabia', name: 'Saudi Arabia', group: 'H' },
    { id: 'uruguay', name: 'Uruguay', group: 'H' },
  ],
  I: [
    { id: 'france', name: 'France', group: 'I' },
    { id: 'senegal', name: 'Senegal', group: 'I' },
    { id: 'iraq', name: 'Iraq', group: 'I' },
    { id: 'norway', name: 'Norway', group: 'I' },
  ],
  J: [
    { id: 'argentina', name: 'Argentina', group: 'J' },
    { id: 'algeria', name: 'Algeria', group: 'J' },
    { id: 'austria', name: 'Austria', group: 'J' },
    { id: 'jordan', name: 'Jordan', group: 'J' },
  ],
  K: [
    { id: 'portugal', name: 'Portugal', group: 'K' },
    { id: 'dr-congo', name: 'DR Congo', group: 'K' },
    { id: 'uzbekistan', name: 'Uzbekistan', group: 'K' },
    { id: 'colombia', name: 'Colombia', group: 'K' },
  ],
  L: [
    { id: 'england', name: 'England', group: 'L' },
    { id: 'croatia', name: 'Croatia', group: 'L' },
    { id: 'ghana', name: 'Ghana', group: 'L' },
    { id: 'panama', name: 'Panama', group: 'L' },
  ],
}

const ROUND_OF_32_TEMPLATES: RoundOf32Template[] = [
  { id: 'M73', label: 'M73', home: { seed: '2A' }, away: { seed: '2B' } },
  {
    id: 'M74',
    label: 'M74',
    home: { seed: '1E' },
    away: { thirdPlaceHost: 'E' },
  },
  { id: 'M75', label: 'M75', home: { seed: '1F' }, away: { seed: '2C' } },
  { id: 'M76', label: 'M76', home: { seed: '1C' }, away: { seed: '2F' } },
  {
    id: 'M77',
    label: 'M77',
    home: { seed: '1I' },
    away: { thirdPlaceHost: 'I' },
  },
  { id: 'M78', label: 'M78', home: { seed: '2E' }, away: { seed: '2I' } },
  {
    id: 'M79',
    label: 'M79',
    home: { seed: '1A' },
    away: { thirdPlaceHost: 'A' },
  },
  {
    id: 'M80',
    label: 'M80',
    home: { seed: '1L' },
    away: { thirdPlaceHost: 'L' },
  },
  {
    id: 'M81',
    label: 'M81',
    home: { seed: '1D' },
    away: { thirdPlaceHost: 'D' },
  },
  {
    id: 'M82',
    label: 'M82',
    home: { seed: '1G' },
    away: { thirdPlaceHost: 'G' },
  },
  { id: 'M83', label: 'M83', home: { seed: '2K' }, away: { seed: '2L' } },
  { id: 'M84', label: 'M84', home: { seed: '1H' }, away: { seed: '2J' } },
  {
    id: 'M85',
    label: 'M85',
    home: { seed: '1B' },
    away: { thirdPlaceHost: 'B' },
  },
  { id: 'M86', label: 'M86', home: { seed: '1J' }, away: { seed: '2H' } },
  {
    id: 'M87',
    label: 'M87',
    home: { seed: '1K' },
    away: { thirdPlaceHost: 'K' },
  },
  { id: 'M88', label: 'M88', home: { seed: '2D' }, away: { seed: '2G' } },
]

const ANNEX_C_OPTIONS = `
EJIFHGLK
HGIDJFLK
EJIDHGLK
EJIDHFLK
EGIDJFLK
EGJDHFLK
EGIDHFLK
EGJDHFLI
EGJDHFIK
HGICJFLK
EJICHGLK
EJICHFLK
EGICJFLK
EGJCHFLK
EGICHFLK
EGJCHFLI
EGJCHFIK
HGICJDLK
CJIDHFLK
CGIDJFLK
CGJDHFLK
CGIDHFLK
CGJDHFLI
CGJDHFIK
EJICHDLK
EGICJDLK
EGJCHDLK
EGICHDLK
EGJCHDLI
EGJCHDIK
CJEDIFLK
CJEDHFLK
CEIDHFLK
CJEDHFLI
CJEDHFIK
CGEDJFLK
CGEDIFLK
CGEDJFLI
CGEDJFIK
CGEDHFLK
CGJDHFLE
CGJDHFEK
CGEDHFLI
CGEDHFIK
CGJDHFEI
HJBFIGLK
EJIBHGLK
EJBFIHLK
EJBFIGLK
EJBFHGLK
EGBFIHLK
EJBFHGLI
EJBFHGIK
HJBDIGLK
HJBDIFLK
IGBDJFLK
HGBDJFLK
HGBDIFLK
HGBDJFLI
HGBDJFIK
EJBDIHLK
EJBDIGLK
EJBDHGLK
EGBDIHLK
EJBDHGLI
EJBDHGIK
EJBDIFLK
EJBDHFLK
EIBDHFLK
EJBDHFLI
EJBDHFIK
EGBDJFLK
EGBDIFLK
EGBDJFLI
EGBDJFIK
EGBDHFLK
HGBDJFLE
HGBDJFEK
EGBDHFLI
EGBDHFIK
HGBDJFEI
HJBCIGLK
HJBCIFLK
IGBCJFLK
HGBCJFLK
HGBCIFLK
HGBCJFLI
HGBCJFIK
EJBCIHLK
EJBCIGLK
EJBCHGLK
EGBCIHLK
EJBCHGLI
EJBCHGIK
EJBCIFLK
EJBCHFLK
EIBCHFLK
EJBCHFLI
EJBCHFIK
EGBCJFLK
EGBCIFLK
EGBCJFLI
EGBCJFIK
EGBCHFLK
HGBCJFLE
HGBCJFEK
EGBCHFLI
EGBCHFIK
HGBCJFEI
HJBCIDLK
IGBCJDLK
HGBCJDLK
HGBCIDLK
HGBCJDLI
HGBCJDIK
CJBDIFLK
CJBDHFLK
CIBDHFLK
CJBDHFLI
CJBDHFIK
CGBDJFLK
CGBDIFLK
CGBDJFLI
CGBDJFIK
CGBDHFLK
CGBDHFLJ
HGBCJFDK
CGBDHFLI
CGBDHFIK
HGBCJFDI
EJBCIDLK
EJBCHDLK
EIBCHDLK
EJBCHDLI
EJBCHDIK
EGBCJDLK
EGBCIDLK
EGBCJDLI
EGBCJDIK
EGBCHDLK
HGBCJDLE
HGBCJDEK
EGBCHDLI
EGBCHDIK
HGBCJDEI
CJBDEFLK
CEBDIFLK
CJBDEFLI
CJBDEFIK
CEBDHFLK
CJBDHFLE
CJBDHFEK
CEBDHFLI
CEBDHFIK
CJBDHFEI
CGBDEFLK
CGBDJFLE
CGBDJFEK
CGBDEFLI
CGBDEFIK
CGBDJFEI
CGBDHFLE
CGBDHFEK
HGBCJFDE
CGBDHFEI
HJIFAGLK
EJIAHGLK
EJIFAHLK
EJIFAGLK
EGJFAHLK
EGIFAHLK
EGJFAHLI
EGJFAHIK
HJIDAGLK
HJIDAFLK
IGJDAFLK
HGJDAFLK
HGIDAFLK
HGJDAFLI
HGJDAFIK
EJIDAHLK
EJIDAGLK
EGJDAHLK
EGIDAHLK
EGJDAHLI
EGJDAHIK
EJIDAFLK
HJEDAFLK
HEIDAFLK
HJEDAFLI
HJEDAFIK
EGJDAFLK
EGIDAFLK
EGJDAFLI
EGJDAFIK
HGEDAFLK
HGJDAFLE
HGJDAFEK
HGEDAFLI
HGEDAFIK
HGJDAFEI
HJICAGLK
HJICAFLK
IGJCAFLK
HGJCAFLK
HGICAFLK
HGJCAFLI
HGJCAFIK
EJICAHLK
EJICAGLK
EGJCAHLK
EGICAHLK
EGJCAHLI
EGJCAHIK
EJICAFLK
HJECAFLK
HEICAFLK
HJECAFLI
HJECAFIK
EGJCAFLK
EGICAFLK
EGJCAFLI
EGJCAFIK
HGECAFLK
HGJCAFLE
HGJCAFEK
HGECAFLI
HGECAFIK
HGJCAFEI
HJICADLK
IGJCADLK
HGJCADLK
HGICADLK
HGJCADLI
HGJCADIK
CJIDAFLK
HJFCADLK
HFICADLK
HJFCADLI
HJFCADIK
CGJDAFLK
CGIDAFLK
CGJDAFLI
CGJDAFIK
HGFCADLK
CGJDAFLH
HGJCAFDK
HGFCADLI
HGFCADIK
HGJCAFDI
EJICADLK
HJECADLK
HEICADLK
HJECADLI
HJECADIK
EGJCADLK
EGICADLK
EGJCADLI
EGJCADIK
HGECADLK
HGJCADLE
HGJCADEK
HGECADLI
HGECADIK
HGJCADEI
CJEDAFLK
CEIDAFLK
CJEDAFLI
CJEDAFIK
HEFCADLK
HJFCADLE
HJECAFDK
HEFCADLI
HEFCADIK
HJECAFDI
CGEDAFLK
CGJDAFLE
CGJDAFEK
CGEDAFLI
CGEDAFIK
CGJDAFEI
HGFCADLE
HGECAFDK
HGJCAFDE
HGECAFDI
HJBAIGLK
HJBAIFLK
IJBFAGLK
HJBFAGLK
HGBAIFLK
HJBFAGLI
HJBFAGIK
EJBAIHLK
EJBAIGLK
EJBAHGLK
EGBAIHLK
EJBAHGLI
EJBAHGIK
EJBAIFLK
EJBFAHLK
EIBFAHLK
EJBFAHLI
EJBFAHIK
EJBFAGLK
EGBAIFLK
EJBFAGLI
EJBFAGIK
EGBFAHLK
HJBFAGLE
HJBFAGEK
EGBFAHLI
EGBFAHIK
HJBFAGEI
IJBDAHLK
IJBDAGLK
HJBDAGLK
IGBDAHLK
HJBDAGLI
HJBDAGIK
IJBDAFLK
HJBDAFLK
HIBDAFLK
HJBDAFLI
HJBDAFIK
FJBDAGLK
IGBDAFLK
FJBDAGLI
FJBDAGIK
HGBDAFLK
HGBDAFLJ
HGBDAFJK
HGBDAFLI
HGBDAFIK
HGBDAFIJ
EJBAIDLK
EJBDAHLK
EIBDAHLK
EJBDAHLI
EJBDAHIK
EJBDAGLK
EGBAIDLK
EJBDAGLI
EJBDAGIK
EGBDAHLK
HJBDAGLE
HJBDAGEK
EGBDAHLI
EGBDAHIK
HJBDAGEI
EJBDAFLK
EIBDAFLK
EJBDAFLI
EJBDAFIK
HEBDAFLK
HJBDAFLE
HJBDAFEK
HEBDAFLI
HEBDAFIK
HJBDAFEI
EGBDAFLK
EGBDAFLJ
EGBDAFJK
EGBDAFLI
EGBDAFIK
EGBDAFIJ
HGBDAFLE
HGBDAFEK
HGBDAFEJ
HGBDAFEI
IJBCAHLK
IJBCAGLK
HJBCAGLK
IGBCAHLK
HJBCAGLI
HJBCAGIK
IJBCAFLK
HJBCAFLK
HIBCAFLK
HJBCAFLI
HJBCAFIK
CJBFAGLK
IGBCAFLK
CJBFAGLI
CJBFAGIK
HGBCAFLK
HGBCAFLJ
HGBCAFJK
HGBCAFLI
HGBCAFIK
HGBCAFIJ
EJBAICLK
EJBCAHLK
EIBCAHLK
EJBCAHLI
EJBCAHIK
EJBCAGLK
EGBAICLK
EJBCAGLI
EJBCAGIK
EGBCAHLK
HJBCAGLE
HJBCAGEK
EGBCAHLI
EGBCAHIK
HJBCAGEI
EJBCAFLK
EIBCAFLK
EJBCAFLI
EJBCAFIK
HEBCAFLK
HJBCAFLE
HJBCAFEK
HEBCAFLI
HEBCAFIK
HJBCAFEI
EGBCAFLK
EGBCAFLJ
EGBCAFJK
EGBCAFLI
EGBCAFIK
EGBCAFIJ
HGBCAFLE
HGBCAFEK
HGBCAFEJ
HGBCAFEI
IJBCADLK
HJBCADLK
HIBCADLK
HJBCADLI
HJBCADIK
CJBDAGLK
IGBCADLK
CJBDAGLI
CJBDAGIK
HGBCADLK
HGBCADLJ
HGBCADJK
HGBCADLI
HGBCADIK
HGBCADIJ
CJBDAFLK
CIBDAFLK
CJBDAFLI
CJBDAFIK
HFBCADLK
CJBDAFLH
HJBCAFDK
HFBCADLI
HFBCADIK
HJBCAFDI
CGBDAFLK
CGBDAFLJ
CGBDAFJK
CGBDAFLI
CGBDAFIK
CGBDAFIJ
CGBDAFLH
HGBCAFDK
HGBCAFDJ
HGBCAFDI
EJBCADLK
EIBCADLK
EJBCADLI
EJBCADIK
HEBCADLK
HJBCADLE
HJBCADEK
HEBCADLI
HEBCADIK
HJBCADEI
EGBCADLK
EGBCADLJ
EGBCADJK
EGBCADLI
EGBCADIK
EGBCADIJ
HGBCADLE
HGBCADEK
HGBCADEJ
HGBCADEI
CEBDAFLK
CJBDAFLE
CJBDAFEK
CEBDAFLI
CEBDAFIK
CJBDAFEI
HFBCADLE
HEBCAFDK
HJBCAFDE
HEBCAFDI
CGBDAFLE
CGBDAFEK
CGBDAFEJ
CGBDAFEI
HGBCAFDE
`
  .trim()
  .split('\n')
  .map((row) => row.trim())

const ANNEX_C_ASSIGNMENTS = new Map<string, string>()

for (const option of ANNEX_C_OPTIONS) {
  ANNEX_C_ASSIGNMENTS.set(
    sortLetters(option.split('') as GroupLetter[]),
    option,
  )
}

export function getAnnexCOptionCount() {
  return ANNEX_C_OPTIONS.length
}

export function createDefaultStandings(): GroupStandings {
  return Object.fromEntries(
    GROUP_LETTERS.map((letter) => [
      letter,
      WORLD_CUP_2026_GROUPS[letter].map((team) => ({ ...team })),
    ]),
  ) as GroupStandings
}

export function getThirdPlaceAssignments(selectedGroups: GroupLetter[]) {
  const normalized = Array.from(new Set(selectedGroups))

  if (normalized.length !== 8) {
    throw new Error('Select exactly eight third-place groups.')
  }

  for (const group of normalized) {
    if (!GROUP_LETTERS.includes(group)) {
      throw new Error(`Unknown group: ${group}`)
    }
  }

  const option = ANNEX_C_ASSIGNMENTS.get(sortLetters(normalized))

  if (!option) {
    throw new Error('No FIFA Annex C mapping found for this combination.')
  }

  return Object.fromEntries(
    THIRD_PLACE_HOSTS.map((host, index) => [
      host,
      option[index] as GroupLetter,
    ]),
  ) as Record<ThirdPlaceHost, GroupLetter>
}

export function buildRoundOf32Matches(
  standings: GroupStandings,
  selectedThirdGroups: GroupLetter[],
): RoundOf32Match[] {
  const assignments = getThirdPlaceAssignments(selectedThirdGroups)

  return ROUND_OF_32_TEMPLATES.map((template) => ({
    id: template.id,
    label: template.label,
    home: resolveSide(template.home, standings, assignments),
    away: resolveSide(template.away, standings, assignments),
  }))
}

export function getTeamById(id: string): Team | null {
  for (const letter of GROUP_LETTERS) {
    const team = WORLD_CUP_2026_GROUPS[letter].find((item) => item.id === id)
    if (team) return team
  }

  return null
}

function resolveSide(
  ref: SeedRef | ThirdPlaceRef,
  standings: GroupStandings,
  assignments: Record<ThirdPlaceHost, GroupLetter>,
): QualifiedTeam {
  if ('thirdPlaceHost' in ref) {
    const group = assignments[ref.thirdPlaceHost]
    return resolveSeed(`3${group}` as SeedCode, standings)
  }

  return resolveSeed(ref.seed, standings)
}

function resolveSeed(seed: SeedCode, standings: GroupStandings): QualifiedTeam {
  const rank = Number(seed[0]) as SeedRank
  const group = seed[1] as GroupLetter
  const team = standings[group]?.[rank - 1]

  if (!team) {
    throw new Error(`Missing team for seed ${seed}`)
  }

  return {
    ...team,
    seed,
  }
}

function sortLetters(letters: GroupLetter[]) {
  return [...letters].sort().join('')
}
